import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetNonAdminAiChatsQueryVariables = Types.Exact<{
  userId: Types.Scalars['String']['input'];
}>;


export type GetNonAdminAiChatsQuery = { __typename?: 'query_root', messages: Array<{ __typename?: 'messages', senderId?: string | null, aiChatId?: string | null, id: any, workspaceId?: number | null, createdAt: any, body?: string | null, user?: { __typename?: 'users', firstName: string, id: string, lastName: string, profilePhotoLink?: string | null } | null, workspace?: { __typename?: 'workspaces', id: number, name: string } | null }> };


export const GetNonAdminAiChatsDocument = gql`
    query getNonAdminAiChats($userId: String!) {
  messages(
    where: {senderId: {_eq: $userId}, aiChatId: {_is_null: false}, parentMessageId: {_is_null: true}}
    order_by: {createdAt: desc}
  ) {
    senderId
    aiChatId
    id
    user {
      firstName
      id
      lastName
      profilePhotoLink
    }
    workspaceId
    workspace {
      id
      name
    }
    createdAt
    body
  }
}
    `;

/**
 * __useGetNonAdminAiChatsQuery__
 *
 * To run a query within a React component, call `useGetNonAdminAiChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNonAdminAiChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNonAdminAiChatsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetNonAdminAiChatsQuery(baseOptions: Apollo.QueryHookOptions<GetNonAdminAiChatsQuery, GetNonAdminAiChatsQueryVariables> & ({ variables: GetNonAdminAiChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNonAdminAiChatsQuery, GetNonAdminAiChatsQueryVariables>(GetNonAdminAiChatsDocument, options);
      }
export function useGetNonAdminAiChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNonAdminAiChatsQuery, GetNonAdminAiChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNonAdminAiChatsQuery, GetNonAdminAiChatsQueryVariables>(GetNonAdminAiChatsDocument, options);
        }
export function useGetNonAdminAiChatsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetNonAdminAiChatsQuery, GetNonAdminAiChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetNonAdminAiChatsQuery, GetNonAdminAiChatsQueryVariables>(GetNonAdminAiChatsDocument, options);
        }
export type GetNonAdminAiChatsQueryHookResult = ReturnType<typeof useGetNonAdminAiChatsQuery>;
export type GetNonAdminAiChatsLazyQueryHookResult = ReturnType<typeof useGetNonAdminAiChatsLazyQuery>;
export type GetNonAdminAiChatsSuspenseQueryHookResult = ReturnType<typeof useGetNonAdminAiChatsSuspenseQuery>;
export type GetNonAdminAiChatsQueryResult = Apollo.QueryResult<GetNonAdminAiChatsQuery, GetNonAdminAiChatsQueryVariables>;